// front-v2.3.0 方式

// 全局库
require('expose-loader?$!expose-loader?jQuery!jquery')
require('expose-loader?moment!moment')
require('layui-src/dist/layui.js')
require('jquery-ui')
require('bootstrap')
require('daterangepicker')
// 功能实现库

// require('../../resources/nova-v1.2/assets/vendor/popper.js/dist/umd/popper.min.js')
require('popper.js/dist/umd/popper.min.js')

// require('../../resources/nova-v1.2/assets/vendor/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js')
require('malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js')

// require('../../resources/front-v2.3.0/assets/vendor/slick-carousel/slick/slick.js')
// require('../../resources/front-v2.3.0/assets/vendor/dzsparallaxer/dzsparallaxer.js')

// require('../../resources/nova-v1.2/assets/vendor/jquery-ui/ui/widgets/menu.js')
// require('../../resources/nova-v1.2/assets/vendor/jquery-ui/ui/widgets/mouse.js')
// require('../../resources/nova-v1.2/assets/vendor/jquery-ui/ui/widgets/autocomplete.js')
require('jquery-ui/ui/widgets/menu.js')
require('jquery-ui/ui/widgets/mouse.js')
require('jquery-ui/ui/widgets/autocomplete.js')

// require('../../resources/nova-v1.2/documentation/assets/vendor/prism/prism.js')
// require('prismjs')

// require('../../resources/nova-v1.2/assets/vendor/select2/dist/js/select2.full.min.js')
require('select2/dist/js/select2.full.min.js')

// require('../../resources/nova-v1.2/assets/vendor/flatpickr/dist/flatpickr.min.js')
require('flatpickr/dist/flatpickr.min.js')

// require('../../resources/nova-v1.2/assets/vendor/table-edits/build/table-edits.min.js')
require('table-edits/build/table-edits.min.js')

// nova 库
// require('../../resources/nova-v1.2/assets/js/hs.core.js')
// require('../../resources/nova-v1.2/assets/js/theme-custom.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.autocomplete.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.bs-tabs.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.chartist-area.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.chartist-bar.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.chartist-donut.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.chartist-pie.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.clipboard.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.datatables.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.file-attach.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.google-geo-chart.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.header-search.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.jquery-validation.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.malihu-scrollbar.js')
// // require('../../resources/nova-v1.2/assets/js/components/hs.masked-input.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.select2.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.side-nav.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.step-form.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.unfold.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.bs-tabs.js')
// require('../../resources/nova-v1.2/assets/js/components/hs.flatpickr.js')

// require('../../resources/nova-v1.2/assets/js/components/hs.go-to.js')

// front-UI 库
// require('../../resources/front-v2.3.0/assets/vendor/hs-megamenu/src/hs.megamenu.js')
// require('../../resources/front-v2.3.0/assets/js/components/hs.header.js')
// require('../../resources/front-v2.3.0/assets/js/components/hs.focus-state.js')
// require('../../resources/front-v2.3.0/assets/js/components/hs.slick-carousel.js')
// require('../../resources/front-v2.3.0/documentation/assets/js/components/hs.autocomplete-local-search.js')
// require('../../resources/front-v2.3.0/assets/js/components/hs.modal-window.js')

require('../../resources/nova-v1.2/dist/assets/js/theme.min.js')

// jstree 库
require('../../resources/lib/jstree/jstree.min.js')




// iconfont
require('../iconfont/iconfont.js')
